import React from 'react';
import { BlogPostTemplate } from '../components/Blog/BlogPostTemplate';
import blogData from '../data/blog/en/narcissism-gaslighting-explained.json';
import { BlogPostData } from '../types/blog';
export function BlogPostNarcissismGaslighting() {
  return <BlogPostTemplate content={blogData as BlogPostData} data-id="element-3942" />;
}